// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document-preview-modal .card {\n    max-width: 1440px;\n    width: 90vw;\n}", ""]);
// Exports
module.exports = exports;
